import type {
    HealthOverviewData,
    HealthOverviewParameter,
    HealthParameterKey,
} from '@/domain/health';

export function findHealthOverviewParameter(
    overview: HealthOverviewData | undefined,
    parameterKey: HealthParameterKey
): HealthOverviewParameter | undefined {
    return overview?.summary.parameters.find((parameter) => parameter.key === parameterKey);
}

/** API scores may be 0–1 fractions or 0–100 percentages. */
export function toHealthPercent(value: number | null | undefined): number | null {
    if (value == null) {
        return null;
    }
    return value <= 1 ? value * 100 : value;
}
